import { OnInit, Directive, Input, Output, EventEmitter } from "@angular/core";


@Directive({
    selector: '[uppercase]',
    host: {
        '[value]': 'upercase',
        '(input)': 'format($event.target.value)'
    }
})
export class Uppercase implements OnInit {
    @Input() uppercase: string;
    @Output() uppercaseChange: EventEmitter<string> = new EventEmitter<string>();
    constructor() {

    }
    ngOnInit() {
        this.uppercase = this.uppercase || '';
        this.format(this.uppercase);

    }
    format(value) {
        value = value.toUpperCase();
        this.uppercaseChange.next(value.trim());
    }
}